import { render } from "./CommissionChart.vue?vue&type=template&id=ab51d136&scoped=true"
import script from "./CommissionChart.vue?vue&type=script&lang=js"
export * from "./CommissionChart.vue?vue&type=script&lang=js"

import "./CommissionChart.vue?vue&type=style&index=0&id=ab51d136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab51d136"]])

export default __exports__